import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import {
  IApiResponse,
  IBoleto,
  IGetBoletosQueryParams,
  IListaPaginada,
  IPostBoletoDownloadBody
} from 'src/app/interfaces';

@Injectable({
  providedIn: 'root'
})
export class BoletoService {
  private readonly baseURL = '/Boleto';

  constructor(private httpClient: HttpClient) {}

  getBoletos(body: IGetBoletosQueryParams) {
    return this.httpClient.post<IApiResponse<IListaPaginada<IBoleto>>>(
      this.baseURL,
      body
    );
  }

  postBoletoDownload(body: IPostBoletoDownloadBody) {
    return this.httpClient.post<IApiResponse<string>>(
      `${this.baseURL}/download`,
      body
    );
  }
}
